import StandardPrompt from "./Standard";
import FullScreenPrompt from "./FullScreen";

const variants = {
  standard: StandardPrompt,
  fullscreen: FullScreenPrompt,
};

export default variants;
